import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import CashReportActions from '../../../../reducers/modules/report/cash-report/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'report/cash-report'

export default class CashReportMiddleware {

  static create(params){
    return (dispatch) => {
      dispatch(CashReportActions.create());
    };
  }

  static update(params){
    return (dispatch) => {
      CashReportMiddleware.showOne(dispatch, params);
      dispatch(CashReportActions.update());
    };
  }
  static resetList(){
    return (dispatch) => {
        dispatch(CashReportActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(CashReportActions.process());
          CashReportMiddleware.showlist(dispatch, params);
        };
  }
  static showExcel(params){
    return (dispatch) => {
        dispatch(CashReportActions.process());
        CashReportMiddleware.beforeShowExcel(dispatch, params);
      };
}

static getPrint(params) {
  return (dispatch) => {
    dispatch(CashReportActions.beforePrint());
    CashReportMiddleware.showPrint(dispatch, params);
  };
}

  static beforeShowExcel(dispatch, params) {
 
  } 

  static listing(params){
    return (dispatch) => {
        dispatch(CashReportActions.process());
        CashReportMiddleware.showlisting(dispatch, params);
      };
}
  static reset(){
    return (dispatch) => {
        dispatch(CashReportActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(CashReportActions.view());
        CashReportMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(CashReportActions.submit());
        CashReportMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(post,params){
    return (dispatch) => {
        dispatch(CashReportActions.submit());
        CashReportMiddleware.saveUpdate(dispatch, params, post);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(CashReportActions.delete());
        CashReportMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      CashReportMiddleware.showHelper(dispatch,params);
      };
  }

  static showPrint(dispatch, params) {
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashReportMiddleware.getToken()}`,
      },
      url: process.env.REST_URL +'report/work-sheet/pdf',
      responseType: "json",
      data:params
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashReportActions.print(response.data.result));
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch, error);
      });
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-customer-chart' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          console.log('data',response)
          dispatch(CashReportActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${CashReportMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            console.log('MIDDLEWARE',response.data)
            dispatch(CashReportActions.listReport(response.data.result));
          }
        })
        .catch((error) => {
          CashReportMiddleware.alertHendler(dispatch,error)
        });
  }

  static showlisting(dispatch, params){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(CashReportActions.list(response.data.result));
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error)
      });
}

  static showOne(dispatch, params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url: url +'/'+params,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashReportActions.view(response.data.result));
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(CashReportActions.process(),CashReportMiddleware.showlist(dispatch, params));
          CashReportMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashReportActions.process(),CashReportMiddleware.showlist(dispatch,search));
          dispatch(CashReportActions.success());
          CashReportMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${CashReportMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          // dispatch(CashReportActions.process(),CashReportActions.showlist(dispatch,search));
          // dispatch(CashReportActions.success());
          // CashReportMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        CashReportMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(CashReportActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(CashReportActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
